import React, { useEffect, useState } from "react";
import { ReactComponent as TopBackground } from "../../assets/img/home/topBackground.svg";
import { ReactComponent as TopBackgroundSmall } from "../../assets/img/home/topBackgroundSmall.svg";
import { ReactComponent as ArrowSvg } from "../../assets/img/home/arrow.svg";
import { ReactComponent as LatestNewsBlockLineSvg } from "../../assets/img/home/latestNewsBlockLine.svg";
import { ReactComponent as LatestNewsBlockLine1280Svg } from "../../assets/img/home/latestNewsBlockLine1280.svg";
import { ReactComponent as LatestNewsBlockLine1170Svg } from "../../assets/img/home/latestNewsBlockLine1170.svg";
import { ReactComponent as LatestNewsBlockLine930Svg } from "../../assets/img/home/latestNewsBlockLine930.svg";
import { ReactComponent as LatestNewsBlockLine690Svg } from "../../assets/img/home/latestNewsBlockLine690.svg";

import { ReactComponent as BottomBackground } from "../../assets/img/home/bottomBackground.svg";
import { ReactComponent as BottomBackgroundSmall } from "../../assets/img/home/bottomBackgroundSmall.svg";

import { ReactComponent as SubscribeBlockLineSvg } from "../../assets/img/home/subscribeBlockLineSvg.svg";
import { ReactComponent as SubscribeBlockLineSmallSvg } from "../../assets/img/home/subscribeBlockLineSmallSvg.svg";

import logoHome from "../../assets/img/home/logoHome.png";
import mobileLogo from "../../assets/img/home/mobileLogo.png";

import latestNewsRight from "../../assets/img/home/latestNewsRight.jpg";
import latestNewsRightSquare from "../../assets/img/home/latestNewsRightSquare.png";

import latestNewsLeft1 from "../../assets/img/home/latestNewsLeft2.jpg";
import latestNewsLeft2 from "../../assets/img/home/latestNewsLeft3.png";
import latestNewsLeft4 from "../../assets/img/home/latestNewsLeft1.jpg";
import latestNewsLeft3 from "../../assets/img/home/latestNewsLeft4.png";

import styles from "./home.module.css";
import Button from "../UI/Button";
import Input from "../UI/Input";
import clsx from "clsx";

const Home = () => {
  const [latestNewsRightImg, setLatestNewsRightImg] = useState(
    latestNewsRightSquare
  );
  const [isIphone, setIsIphone] = useState(false);
  const resizeHandler = () => {
    if (window.innerWidth < 1440) {
      setLatestNewsRightImg(latestNewsRight);
    } else {
      setLatestNewsRightImg(latestNewsRightSquare);
    }
  };
  useEffect(() => {
    if (window.innerWidth < 1440) {
      setLatestNewsRightImg(latestNewsRight);
    }
    if (!/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      setIsIphone(true);
    }
    window.scrollTo(0, 0);
    window.addEventListener("resize", resizeHandler);
    resizeHandler();
    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, []);
  return (
    <div className={styles.container}>
      <div className={styles.homeTop}>
        <div className={styles.homeTopBgBlack} />
        <TopBackground className={styles.topBackgroundSvg} />
        <TopBackgroundSmall className={styles.topBackgroundSmallSvg} />

        <div className={styles.topInfoBlock}>
          <img
            src={logoHome}
            alt="logoHome"
            className={styles.topInfoBlockLogo}
          />
          <img src={mobileLogo} alt="logoHome" className={styles.mobileLogo} />

          <div className={styles.topInfoBlockTopText}>
            Ready To Dive Into the Future of Gaming?
          </div>
          <div className={styles.topInfoBlockText}>
            Welcome to Mech.com - the next generation video game powered by
            cutting-edge AI technology. Each player in our game owns a unique
            digital collectible known as a Mech, giving you unparalleled control
            and customization. Build, battle, and earn real money in the Mech
            universe, where every single item is player-owned. Create your own
            stores, shops, and battle arenas, or just connect with like-minded
            individuals and forge new friendships while exploring new worlds.
            Gear up, power on, and get ready to experience a gaming adventure
            like no other.
          </div>
          <div className={styles.topInfoBlockButtonBlock}>
            <div
            onClick={() => {
                      window.open(
                        "https://alpha.world.mech.com/app/bot"
                      );
                    }}>
                <Button 
                  isSmall={false}
                  style={{color: "#ffca38"}}
                  > 
                PLAY NOW FOR FREE
                </Button>

            </div>
          </div>
        </div>
      </div>
      <div className={styles.latestNewsBlock}>
        <div className={styles.latestNewsBlockHeader}>
          LATEST NEWS
          <LatestNewsBlockLineSvg className={styles.latestNewsBlockLineSvg} />
          <LatestNewsBlockLine1280Svg
            className={styles.latestNewsBlockLine1280Svg}
          />
          <LatestNewsBlockLine1170Svg
            className={styles.latestNewsBlockLine1170Svg}
          />
          <LatestNewsBlockLine930Svg
            className={styles.latestNewsBlockLine930Svg}
          />
          <LatestNewsBlockLine690Svg
            className={styles.latestNewsBlockLine690Svg}
          />
        </div>
        <div className={styles.newsGrid}>
          <div className={clsx(styles.newsOne, styles.newsItem)}>
            <div
              className={styles.newsItemHoverBgc}
              onClick={() => {
                window.open(
                  "https://blog.mech.com/news/the-varia-district-re-opening/"
                );
              }}
            />
            <img src={latestNewsRightImg} alt="latest news img" />
            <div>
              <h2>The Varia District Re-Opening</h2>
              <div>
                The gates of Varia are re-opening soon and along with it, new
                secrets will be revealed. What is hiding in the completely
                frozen area and how does that affect the creation of usable
                in-game items?
              </div>
            </div>
          </div>
          <div className={clsx(styles.newsTwo, styles.newsItem)}>
            <div
              className={styles.newsItemHoverBgc}
              onClick={() => {
                window.open(
                  "https://blog.mech.com/news/match-3-mini-game-release/"
                );
              }}
            />
            <img src={latestNewsLeft1} alt="latest news img" />
            <div>
              <h2>Match 3 Mini-Game Release</h2>
              <div>
                Match 3, even though it’s one of the simplest, has been one of
                the most played gameplay types in the mobile gaming world for
                years. Mech has decided to embrace this mode and make it the
                primary way of mining for Ore in the Mech universe!
              </div>
            </div>
          </div>
          <div className={clsx(styles.newsThree, styles.newsItem)}>
            <div
              className={styles.newsItemHoverBgc}
              onClick={() => {
                window.open(
                  "https://blog.mech.com/web-3/how-mech-land-is-disrupting-the-whole-metaverse/"
                );
              }}
            />
            <img src={latestNewsLeft2} alt="latest news img" />
            <div>
              <h2>Mech Land Is Disrupting The Whole Metaverse</h2>
              <div>
                In the past few months, owning digital real estate has become
                somewhat of a trend with all web3 blockchain games. We’ve seen
                projects sell thousands of plots in many different forms...
              </div>
            </div>
          </div>
          <div className={clsx(styles.newsFour, styles.newsItem)}>
            <div
              className={styles.newsItemHoverBgc}
              onClick={() => {
                window.open(
                  "https://blog.mech.com/app/limitless-mech-gameplay-modes/"
                );
              }}
            />
            <img src={latestNewsLeft3} alt="latest news img" />
            <div>
              <h2>Limitless Mech Gameplay Modes</h2>
              <div>
                With Mechs AI powered Creator Tools, there is virtually no limit
                on how many different game modes/types can exist. On top of the
                countless gameplay types like Battle Royale, Capture The Flag,
                Drift Racing and others built by Mech, land owners will be able
                to create their own games with custom designs, rule sets and
                ideas.
              </div>
            </div>
          </div>
          <div className={clsx(styles.newsFive, styles.newsItem)}>
            <div
              className={styles.newsItemHoverBgc}
              onClick={() => {
                window.open(
                  "https://wiki.mech.com/mech.com-lore/lore/chapter-1.-meena"
                );
              }}
            />
            <img src={latestNewsLeft4} alt="latest news img" />
            <div>
              <h2>Lore: Chapter #1 Release</h2>
              <div>
                The air was dusty and brittle, even through her mask it was
                coating her teeth in grime. The incoming ship was kicking up all
                the vegetation she had been so carefully picking through just
                moments before.
              </div>
            </div>
          </div>
        </div>
        <div
          className={clsx(styles.latestNewsMoreNewsBlock, {
            [styles.latestNewsMoreNewsBlockIphone]: isIphone,
          })}
          onClick={() => {
            window.open("http://blog.mech.com");
          }}
        >
          MORE NEWS <ArrowSvg />
        </div>
      </div>
      <div className={styles.subscribeBlock}>
        <BottomBackground className={styles.bottomBackgroundSvg} />
        <BottomBackgroundSmall className={styles.bottomBackgroundSmallSvg} />
        <div className={styles.subscribeBlockHeader}>
          SUBSCRIBE
          <SubscribeBlockLineSvg className={styles.subscribeBlockHeaderSvg} />
          <SubscribeBlockLineSmallSvg
            className={styles.subscribeBlockHeaderSmallSvg}
          />
        </div>
        <div className={styles.subscribeText}>
        Keep up-to-date with the latest digital asset drops, game releases, and updates by subscribing now. Enter your email below to stay informed and learn more:
        </div>
        <div className={styles.subscribeInputBlock}>
          <form
            action="https://treysmith.us18.list-manage.com/subscribe/post?u=47aa2f57c059e12798b17c893&amp;id=993d5d16fc"
            method="post"
            target="_blank"
            noValidate
          >
            <Input type="email" name="EMAIL" />
            <Button isSmall={false}> Subscribe</Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Home;
